import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapViewStore from '../../../../stores/useMapViewStore';
import MapStaticObjectModal from '../../../../ui/modals/map/MapStaticObjectModal';
import { closeMapSelectionModal } from './closeMapSelectionModal';

/** Static map object modal — City Hall etc. (`activeModal === 'mapObject'`). */
export default function MapStaticObjectHost() {
  const isMapObjectModalOpen = useMapModalStore((s) => s.activeModal === 'mapObject');
  const electionCityHallScreen = useMapModalStore((s) => s.payload.electionCityHallScreen);
  const selectedMapObject = useMapViewStore((s) => s.selectedMapObject);

  return (
        <MapStaticObjectModal
          isOpen={isMapObjectModalOpen}
          staticObject={selectedMapObject}
          onClose={closeMapSelectionModal}
          initialScreen={electionCityHallScreen ?? undefined}
        />
  );
}
